<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        v-if="!loading"
        class="mx-auto"
        outlined>
        
        <v-card-text class="py-0">

          <v-timeline
            align-top
            dense
            v-for="program in programs"
            :key="program.id"
          > 
            <v-timeline-item
              color="blue"
              medium>
                <v-col class="ma-auto" style="background-color: rgb(0, 187, 255); color: #FFF; border-radius: 4px;">
                  <h1 align="center" style="font-weight: 400; font-size:18px;">
                    {{ (program.name)? program.name+': '+convertDate(program.date):convertDate(program.date) }}
                  </h1>
                </v-col>
            </v-timeline-item>

            <v-timeline-item
              :color="(activity.type_of_activity_id==1)?colors.other:((activity.type_of_activity_id==2)?colors.presential:((activity.type_of_activity_id==3)?colors.virtual:colors.hybrid))"
              small
              v-for="activity in program.activities"
              :key="activity.id">
              <v-row class="pt-1" style="margin-bottom: .1rem;">
                <v-col cols="3">
                  <strong>{{ activity.hour }}</strong>
                </v-col>
                <v-col>
                  <strong>{{ activity.name  }}</strong>
                  <strong 
                    v-show="activity.type_of_activity_id!=1"
                    class="text--secondary font-italic">
                    {{ ' ('+activity.type_of_activity_name.toLowerCase()+')' }}
                  </strong>
                  <div class="text-caption font-weight-bold" v-if="activity.place">
                    <v-icon small>
                      mdi-map-marker
                    </v-icon>
                    {{ activity.place }}
                  </div>
                  
                  <div class="text-caption pt-2">
                    {{ activity.description }}
                  </div>

                  <div class="pt-1">
                    <v-btn
                      x-small
                      text
                      outlined
                      class="mr-1"
                      color="info"
                      @click="showActivity(activity)">
                      Ver más
                    </v-btn>

                    <v-btn
                      x-small
                      text
                      outlined
                      class="mr-1"
                      color="info"
                      disabled
                      v-if="activity.type_of_activity_id==3||activity.type_of_activity_id==4">
                      Ir al auditorio
                    </v-btn>
                  </div>
                </v-col>

              </v-row>
            </v-timeline-item>

          </v-timeline>
        </v-card-text>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'programEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Cargando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_activity"
      max-width="560"
    >
      <v-card>
        <v-card-title class="text-h5">
          <strong>{{ name  }}</strong>
          <small>
            <strong 
              v-show="type_of_activity_id!=1"
              class="text--secondary font-italic">
              {{ ' ('+type_of_activity_name.toLowerCase()+')' }}
            </strong>
          </small>
            
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="text-caption" v-if="description">
              <strong>Descripción:</strong>
              <p>{{ description }}</p>
            </v-col>

            <v-col cols="12" class="text-caption" v-if="target_audience">
              <strong>Público objetivo:</strong>
              <p>{{ target_audience }}</p>
            </v-col>

            <v-col cols="12" class="text-caption" v-if="auditorium">
              <strong>Auditorio:</strong>
              <p>{{ auditorium.name }}</p>
            </v-col>

            <v-col cols="6" class="text-caption" v-if="place">
              <strong>Lugar:</strong>
              <p>{{ place }}</p>
            </v-col>

            <v-col cols="6" class="text-caption" v-if="hour">
              <strong>Horario:</strong>
              <p>{{ hour }}</p>
            </v-col>

            <v-col cols="6" class="text-caption" v-if="speakers && speakers.length >0">
              <strong>Speakers:</strong>
              <div v-for="speaker in speakers" :key="speaker.id">
                <v-icon color="primary" class="mt-0 mb-2">
                  mdi-bullhorn-outline
                </v-icon>
                <label class="mt-0 mb-0" color="primary">{{ speaker.name }}</label>
              </div>
            </v-col>

            <v-col cols="6" class="text-caption" v-if="moderators && moderators.length >0">
              <strong>Moderador:</strong>
              <div class="pt-1" v-for="moderator in moderators" :key="moderator.id">
                <label>{{ moderator.name }}</label>
              </div>
            </v-col>

          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="dialog_activity = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'showAllProgramEdition',

    data: () => ({
      loading:true,

      edition_id:null,

      dialog_activity: false,
      activity_show:[],
      name: null,
      type_of_activity_id: null,
      type_of_activity_name: '',
      description: null,
      target_audience: null,
      place: null,
      hour: null,
      speakers: null,
      moderators: null,
      auditorium: null,

      programs:[],
      colors:{
        other: '#FFFFFF',
        presential: '#FF41BE',
        virtual: '#17FF38',
        hybrid: '#03FFF5',
      }
    }),

    methods:{
      convertDate(date) {
        const parts = date.split('-');
        const day = parts[2];
        const month = parts[1];
        const year = parts[0];

        return `${day}/${month}/${year}`;
      },

      async getPrograms()
      {
        await axios.get('admin/editions/'+this.edition_id+'/program-edition/all').then(response =>{
          this.programs = response.data.data.program

          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      showActivity(activity){
        this.activity_show = activity
        
        this.name                   = activity.name
        this.type_of_activity_name  = activity.type_of_activity_name
        this.type_of_activity_id    = activity.type_of_activity_id
        this.description            = activity.description
        this.target_audience        = activity.target_audience
        this.place                  = activity.place
        this.hour                   = activity.hour
        this.auditorium             = activity.auditorium
        this.speakers               = activity.speakers
        this.moderators             = activity.moderators  

        this.dialog_activity        = true
      }
    },
    created(){
      this.edition_id = this.$route.params.edition_id
      this.getPrograms()
    },
  }
</script>
